export default "__VITE_ASSET__CPFvThQN__"